<template>
	<div class="worker-talk-room">
		<Loading v-if="loading" opacity="0.5"/>
		<div class="header">
			<v-toolbar flat color="primary" height="60px">
				<v-toolbar-items>
					<v-btn flat dark @click="onClickBack"><v-icon>chevron_left</v-icon></v-btn>
				</v-toolbar-items>
				<v-toolbar-title class="subheading white--text" v-if="display">
					<div class="project-name">{{ headerInfo.project_name }}</div>
					<div class="schedule_title">{{ headerInfo.title }}<br></div>
					<div class="term">{{ textBeginDate }} ～ {{ textEndDate }}</div>
				</v-toolbar-title>
			</v-toolbar>
		</div>
		<div class="talk-message" v-bind:style="messageHeight" v-if="display">
			<div
				class="presence-message"
				v-if="messagePresence"
				v-on:scroll="onVScroll"
			>
				<div class="loading-message" v-if="!reading_stop">loading...</div>
				<div v-for="(day_message, index) in messageInfo" v-bind:key="index">
					<div class="talk-message-date">{{ day_message.date.show_date }}</div>
					<div 
						v-for="m in day_message.message"
						v-bind:key="m.code"
					>
						<MSTalkMessagePhotoAlbum
							v-if="isPhotoAlbum(m)"
							v-bind:myMemberID="$route.params.id"
							v-bind:message="m"
						/>
						<MSTalkMessageText
							v-else
							v-bind:message="m"
						/>
					</div>
				</div>
			</div>
			<div class="no-message" v-else>
				<span style="text-align:center">「アルバムを作成」ボタンを押し、<br>アルバムを作成してください。</span>
			</div>
		</div>
		<div class="footer" v-if="display">
			<v-btn flat large block color="primary" v-on:click="onClickCreateAlbum" class="btn-create-album">アルバムを作成</v-btn>
		</div>
	</div>
</template>
<script>
import clonedeep from 'lodash/cloneDeep';
import Loading from '../Loading';
import MSTalkMessagePhotoAlbum from'./MSTalkMessagePhotoAlbum';
import MSTalkMessageText from'./MSTalkMessageText';
import Notification from '../../classes/Notification';
import APIClient from '../../classes/APIClient';
import { GANTTBOARD_EVENT_ID } from '../../data/Const';
import Util from '../../classes/Util';

const weeks_names = ['日', '月', '火', '水', '木', '金', '土'];
const HEADER_HEIGHT = 60;
const BOTTOM_HEIGHT = 60;
const NEWER = {
	FALSE: 0,
	TRUE: 1,
}
const GET_MESSAGE_COUNT = 10;


export default {
	name: 'MSTalkRoom',
	components: {
		Loading,
		MSTalkMessagePhotoAlbum,
		MSTalkMessageText,
	},
	data () {
		return {
			room_info: null,
			message: null,
			reading_stop: false,
			loading: false,
			api: new APIClient(this.$store),
			reading: false,
		}
	},
	methods: {
		initData: async function() {
			this.room_info = null,
			this.message = null,
			this.reading_stop = false;
			this.loading = true;
			
			await this.api.getTalkRoomInfo(this.$route.params.talkroom_id, GET_MESSAGE_COUNT, null, false)
				.then((res) => {
					this.room_info = res.data.room_info;
					this.message = res.data.talk_message.reverse();
					this.$nextTick(() => {
						this.scrollBottom();
					});
					if (res.data.talk_message.length < 10)
						this.reading_stop = true;
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					switch (e.response.status) {
					case 404:
						this.$store.dispatch('addNotification', Notification.error('案件、もしくはスケジュールが削除されました'));
						break;
					default:
						this.$store.dispatch('addNotification', Notification.error('データの取得に失敗しました'));
					}
				})
				.then(() => {
					this.loading = false;
				});
		},
		onAppendMessage: function(appended) {
			if (appended.talkroom_id != this.$route.params.talkroom_id)
				return;

			let tm_new_id = this.message[this.message.length - 1].code;
			this.api.getTalkRoomInfo(this.$route.params.talkroom_id, -1, tm_new_id, NEWER.TRUE)
				.then((res) => {
					res.data.talk_message.filter(add => {
						return this.message.findIndex(m => m.code === add.code) < 0;
					}).forEach(add_message => {
						this.message.push(add_message);
					});
					this.$store.dispatch('addNotification', Notification.info('メッセージが追加されました'));
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					switch (e.response.status) {
					case 404:
						this.$store.dispatch('addNotification', Notification.error('案件、もしくはスケジュールが削除されました'));
						this.room_info = null;
						break;
					default:
						this.$store.dispatch('addNotification', Notification.error('データの取得に失敗しました'));
					}
				});
		},
		onUpdateDataSet: function() {
			this.api.getTalkRoomInfo(this.$route.params.talkroom_id, 0, null, NEWER.TRUE)
				.then((res) => {
					this.room_info = res.data.room_info;
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					switch (e.response.status) {
					case 404:
						this.$store.dispatch('addNotification', Notification.error('案件、もしくはスケジュールが削除されました'));
						this.room_info = null;
						break;
					default:
						this.$store.dispatch('addNotification', Notification.error('データの取得に失敗しました'));
					}
				});
		},
		onClickBack: function() {
			this.$router.push({
				name: 'MemberSchedule',
				params: {
					'contractor_id': this.$route.params.contractor_id,
					'id': this.$route.params.id,
				},
			});
		},
		onClickCreateAlbum: function() {
			this.$router.push({
				name: 'MSTalkMessageEditPhotoAlbum',
				params: {
					'contractor_id': this.$route.params.contractor_id,
					'id': this.$route.params.id,
					'talkroom_id': this.$route.params.talkroom_id,
				},
			});
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
		scrollBottom: function() {
			let el_target = this.$el.closest('.worker-talk-room').querySelector('.talk-message .presence-message');
			if (el_target)
				el_target.scrollTop = el_target.scrollHeight;
		},
		onVScroll: function() {
			if (this.reading_stop)
				return ;
				
			if (this.reading)
				return ;
				
			let el_target = this.$el.closest('.worker-talk-room').querySelector('.talk-message .presence-message');
			if (el_target.scrollTop !== 0)
				return ;

			let scroll_top_before = el_target.scrollTop;
			let scroll_height_before = el_target.scrollHeight;
			this.reading = true;
			
			this.api.getTalkRoomInfo(this.$route.params.talkroom_id, GET_MESSAGE_COUNT, this.message[0].code, NEWER.FALSE)
				.then((res) => {
					res.data.talk_message.filter(add => {
						return this.message.findIndex(m => m.code === add.code) < 0;
					}).forEach(add_message => {
						this.message.unshift(add_message);
					});
					this.$nextTick(() => {
						let scroll_height_after = el_target.scrollHeight;
						el_target.scrollTop = scroll_height_after - scroll_height_before + scroll_top_before;
						this.reading = false;
					});
					if (res.data.talk_message.length < 10)
						this.reading_stop = true;
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					switch (e.response.status) {
					case 404:
						this.$store.dispatch('addNotification', Notification.error('案件、もしくはスケジュールが削除されました'));
						this.room_info = null;
						break;
					default:
						this.$store.dispatch('addNotification', Notification.error('データの取得に失敗しました'));
					}
				});
		},
	},
	computed: {
		display: function() {
			return this.room_info !== undefined && this.room_info !== null;
		},
		headerInfo: function() {
			if (!this.room_info)
				return null;
			return {
				project_name: this.room_info.project_name,
				title: this.room_info.schedule_title,
				begin: this.room_info.schedule_begin,
				end: this.room_info.schedule_end,
			};
		},
		textBeginDate: function() {
			if (!this.headerInfo)
				return '';
			let begin = this.headerInfo.begin;
			return begin.slice(0,4) + '年' + begin.slice(4,6) + '月' + begin.slice(6,8) + '日';
		},
		textEndDate: function() {
			if (!this.headerInfo)
				return '';
			let end = this.headerInfo.end;
			return end.slice(0,4) + '年' + end.slice(4,6) + '月' + end.slice(6,8) + '日';
		},
		isPhotoAlbum: function() {
			return function(message) {
				if (message.kind === 2) 
					return true;
				return false;
			};
		},
		messagePresence: function() {
			if (this.message.length > 0)
				return true;
			return false;
		},
		messageInfo: function() {
			return clonedeep(this.message).reduce((acc, cur) => {
				let dt = new Date(cur.insert_at.slice(0,4) + '-' + cur.insert_at.slice(4,6) + '-' + cur.insert_at.slice(6,8) + 'T' + cur.insert_at.slice(8,10) + ':' + cur.insert_at.slice(10,12) + ':' + cur.insert_at.slice(12,14) + 'Z');
				cur.insert_at = {
					'datetime': dt,
					'year': dt.getFullYear(),
					'month': ("0" + (dt.getMonth() + 1)).slice(-2),
					'day': ("0" + dt.getDate()).slice(-2),
					'hour': dt.getHours(),
					'minute': ("0" + dt.getMinutes()).slice(-2),
					'second': dt.getSeconds(),
					'week': weeks_names[dt.getDay()],
				};
				let same_date_message = acc.find(a => a.date.year === cur.insert_at.year && a.date.month === cur.insert_at.month &&a.date.day === cur.insert_at.day);
				if (same_date_message) {
					same_date_message.message.push(cur);
				} else {
					acc.push({
						date: {
							'year': cur.insert_at.year,
							'month': cur.insert_at.month,
							'day': cur.insert_at.day,
							'show_date': cur.insert_at.year + '年' + cur.insert_at.month + '月' + cur.insert_at.day + '日(' + cur.insert_at.week + ')',
						},
						message: [cur],
					});
				}
				return acc;
			}, []);
		},
		messageHeight: function() {
			return { 
				height: (this.$store.getters.height - HEADER_HEIGHT -BOTTOM_HEIGHT) + 'px',
			};
		},
	},
	mounted: function() {
		this.initData();
	},
	created: function() {
		window.addEventListener('scroll' , this.onVScroll, false);
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.TALKROOM_APPEND_MESSAGE,
			listener: this.onAppendMessage,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
	},
	beforeDestroy: function() {
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.TALKROOM_APPEND_MESSAGE,
			listener: this.onAppendMessage,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
		window.removeEventListener('scroll' , this.onVScroll);
		window.removeEventListener('resize', this.onWindowResize);
	},
	beforeRouteUpdate(to, from, next) {
		this.initData();
		next();
	},
};
</script>
<style>
.worker-talk-room {
	width: 100%;
	overflow: hidden;
	transition:1s;
}
.worker-talk-room .header{
	position :relative;
	width: 100%;
	z-index: 102;
}
.worker-talk-room .project-name {
	overflow: hidden;
	font-size: 14px;
}
.worker-talk-room .schedule_title {
	font-size: 11px;
}
.worker-talk-room .term {
	font-size: 11px;
}
.worker-talk-room .talk-message {
}
.worker-talk-room .presence-message {
	height: 100%;
	overflow-y: scroll;
	overflow-x: hidden;
}
.worker-talk-room .loading-message {
	text-align: center;
}
.worker-talk-room .no-message {
	display: flex;
	justify-content: center;
	padding: 60px;
	color: #1976d2;
}
.worker-talk-room .talk-message-date {
	font-size: 24px;
	margin-top: 20px;
	padding: 10px;
}
.worker-talk-room .footer {
	position :relative;
	display: flex;
	justify-content: center;
	background-color: #ffffff;
	width: 100%;
	height: 60px;
	z-index: 102;
}
.worker-talk-room .btn-create-album {
	color: #1976d2;
	border: solid 1px #1976d2;
	border-radius: 20px;
	margin: 10px 100px;
	min-width: 200px;
}
</style>
